export const PLACEMENT_STATUS = Object.freeze({
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  FILLED: 'FILLED',
  CANCELED: 'CANCELED',
  CANCEL_PENDING: 'CANCEL_PENDING',
  FAILED: 'FAILED',
  MISSING: 'MISSING',
});
